export const loadPersistedData = (key) => {
	let value;
	const serializedData = localStorage.getItem(key)
	if (serializedData === null) {
		return null
	}
	try {
		value = JSON.parse(serializedData)
	} catch (err) {
		value = serializedData
	}
	return value
}


export const persistData = (key, state) => {
	try {
		const serializedDate = key === "theme" || key === "lang" ? state : JSON.stringify(state)
		localStorage.setItem(key, serializedDate)
	} catch (err) {
		console.log(err)
	}
}

